module.exports = __webpack_public_path__ + "img/24-r.543bccd8.png";